import React, { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import Colors from 'theme/colors';

interface Props {
  title: string;
  children: ReactNode;
  showBackToTools?: boolean;
}

const shell: any = {
  minHeight: '100vh',
  backgroundColor: Colors.SECOND_COLOR,
  fontFamily: 'sans-serif',
  color: Colors.TEXT,
};

const header: any = {
  backgroundColor: Colors.MAIN_COLOR,
  minHeight: 56,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
};

const headerTitle: any = {
  color: Colors.WHITE,
  fontSize: 18,
  fontWeight: 700,
  flex: 1,
  textAlign: 'center',
  margin: 0,
};

const backBtn: any = {
  background: 'transparent',
  border: 'none',
  color: Colors.WHITE,
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  padding: '8px 4px',
  minWidth: 88,
  textAlign: 'left',
};

const spacer: any = { minWidth: 88 };

const content: any = {
  maxWidth: 720,
  margin: '0 auto',
  padding: '20px 16px 40px',
};

const ToolLayout: FC<Props> = ({ title, children, showBackToTools = true }) => {
  const history = useHistory();

  return (
    <div style={shell} data-no-ads="true">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <header style={header}>
        {showBackToTools ? (
          <button
            type="button"
            style={backBtn}
            onClick={() => history.push('/tools')}
            aria-label="Về trang công cụ"
          >
            ← Công cụ
          </button>
        ) : (
          <div style={spacer} />
        )}
        <h1 style={headerTitle}>{title}</h1>
        <div style={spacer} />
      </header>
      <main style={content}>{children}</main>
    </div>
  );
};

export default ToolLayout;
